import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {copyrightPolicy} from '#/lib/policies'
import {PolicyDocument} from '#/components/PolicyDocument'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'CopyrightPolicy'>
export const CopyrightPolicyScreen = (_props: Props) => {
  return <PolicyDocument {...copyrightPolicy} />
}
